import { builderFragment } from './fragments.gql'

export default `query CollectionQuery($slug: String!) {
  collection(filter: {slug: {eq: $slug}}) {
    slug
    showTopBanner
    ${builderFragment}
  }
}`
